export const FEEDBACK_CATEGORIES = [
  {
    value: 'applied_received_grant',
    label: 'Applied/received grant already',
  },
  { value: 'incorrect_info', label: 'Incorrect information' },
  { value: 'dislike', label: "Don't like opportunity" },
  { value: 'bad_match', label: 'Not a good match' },
  { value: 'outdated_questions', label: 'Funder updated their questions' },
]
